'use client';
import TransitionLink from './TransitionLink';

export default function RouterLinkAdapter(props: React.ComponentProps<typeof TransitionLink>) {
  return <TransitionLink {...props} />;
}
